/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppBar from 'material-ui/AppBar'
import Tabs, { Tab } from 'material-ui/Tabs'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  onChange: PropTypes.func.isRequired,
  tabOptions: PropTypes.array.isRequired,
  tabState: PropTypes.number.isRequired
}

const styles = theme => ({

})

export class TabDisplay extends Component {
  renderTab() {
    const { tabOptions } = this.props
    let markup = null
    if (tabOptions) {
      markup = tabOptions.map((tab, index) => {
        return (
          <Tab key={index} value={index} label={tab} />
        )
      })
    }
    return markup
  }

  render() {
    const { tabState, onChange } = this.props
    return (
      <section>
        <AppBar position="static" color="default">
          <Tabs value={tabState} onChange={onChange}>
            {this.renderTab()}
          </Tabs>
        </AppBar>
      </section>
    )
  }
}

TabDisplay.propTypes = PROP_TYPES

export default withStyles(styles)(TabDisplay)
